import type { useToast as originalUseToast } from '#imports';

export const useCustomToast: typeof originalUseToast = () => {
  const nuxtApp = useNuxtApp();

  return nuxtApp.vueApp.config.globalProperties.$toast;
};
